<template>
    <div class="u-padding-narrow">
        <div class="u-margin-bottom"></div>
        <div class="layout layout--center | u-full-height">
            <div class="layout__item u-4/5-desk">
                <header-partial :domain="domain" />

                <div class="page-block">
                    <technical-management-tabs :step="3" :domain="domain" :service="firstServiceForDomain" />

                    <hosting-overview v-if="service" :domain="domain" :subscription="service" dusk="hosting-item" />
                    <div v-else class="page-block__item-wrapper">
                        {{ trans('hosting.no-hosting') }}

                        <div v-if="canOrder" class="page-block__item-wrapper">
                            <div class="layout | u-text-right">
                                <div class="layout__item u-1/4-desk">
                                    <customer-router-link
                                        :to="{ name: 'orderHostingSelect', params: { domain: domain } }"
                                    >
                                        <button
                                            type="button"
                                            class="btn btn--ghost btn--ghost-full-width"
                                            dusk="order-hosting"
                                        >
                                            {{ trans('hosting.order') }}
                                        </button>
                                    </customer-router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import HostingOverview from '@/components/technical-management/HostingOverview.vue';
import { HeaderPartial, serviceMixin, servicesPageMixin } from 'relapp-technical-management';

export default {
    components: {
        HeaderPartial,
        HostingOverview
    },
    mixins: [serviceMixin, servicesPageMixin],
    /**
     * Add all the properties found in the data object to Vue’s reactivity system.
     *
     * @return {object}
     */
    data() {
        return {
            serviceType: 'hosting'
        };
    },
    /**
     * Called after the instance has been mounted.
     */
    mounted() {
        this.getServices();
    },
    /**
     * Get the meta info for the page.
     *
     * @return {object}
     */
    metaInfo() {
        return {
            title: trans('page.hosting.title', { domain: this.domain })
        };
    }
};
</script>
